export interface UserState {
  user: any;
}

export const initialUserState: UserState = {
  user: null
};